import React from 'react';
import OpenBetsOrder from './Order/Order';
import BetHistoryPeriod from './Period/Period';
import BetHistoryStatus from './Status/Status';
import Source from './Source/Source';
import VoucherCode from './VoucherCode/VoucherCode';
import { getTranslation } from '../../../../utils/translation';

export default function Filters({
    tabs,
    selectedTab,
    periods,
    rangePeriod,
    selectedPeriod,
    setSelectedPeriod,
    orders,
    openBets,
    bettingHistory,
    setBettingHistory,
    onOpenBetsSourceChange,
    onOpenBetsOrderChange,
    onOpenBetsVoucherCodeChange,
    onBetHistorySourceChange,
    onBetHistoryPeriodChange,
    onBetHistoryStatusChange,
    onBetHistoryVoucherCodeChange,
    getOpenBetTickets,
    getBetHistoryTickets,
    clearData,
}) {
    const onOpenBetsSearch = () => {
        getOpenBetTickets(openBets);
    };

    const onBetHistorySearch = () => {
        getBetHistoryTickets(bettingHistory);
    };

    return (
        <>
            <div className='filters'>
                {selectedTab === tabs.openBets && (
                    <>
                        <Source
                            selectedSource={openBets.source}
                            onSourceChange={onOpenBetsSourceChange}
                        />
                        <OpenBetsOrder
                            orders={orders}
                            selectedOrder={openBets.order}
                            onOpenBetsOrderChange={onOpenBetsOrderChange}
                        />
                        <VoucherCode
                            voucherCode={openBets.voucherCode}
                            onChange={onOpenBetsVoucherCodeChange}
                        />
                        <button className='filter-button' onClick={onOpenBetsSearch}>
                            {getTranslation('filtersSearchButton')}
                        </button>
                    </>
                )}

                {selectedTab === tabs.bettingHistory && (
                    <>
                        <Source
                            selectedSource={bettingHistory.source}
                            onSourceChange={onBetHistorySourceChange}
                        />
                        <BetHistoryStatus
                            selectedStatus={bettingHistory.status}
                            onBetHistoryStatusChange={onBetHistoryStatusChange}
                        />
                        <VoucherCode
                            voucherCode={bettingHistory.voucherCode}
                            onChange={onBetHistoryVoucherCodeChange}
                        />
                        <BetHistoryPeriod
                            periods={periods}
                            bettingHistory={bettingHistory}
                            setBettingHistory={setBettingHistory}
                            onBetHistoryPeriodChange={onBetHistoryPeriodChange}
                            getBetHistoryTickets={getBetHistoryTickets}
                            selectedPeriod={selectedPeriod}
                            setSelectedPeriod={setSelectedPeriod}
                            rangePeriod={rangePeriod}
                            clearData={clearData}
                            onSearch={onBetHistorySearch}
                        />
                    </>
                )}
            </div>
        </>
    );
}
